import { redirect } from '@tanstack/react-router';
import type { Store } from 'redux';
import { userSelectors } from 'store/glue/user';
import Types from 'Types';
import { JwtFeature } from 'utility/jwt';

import { routes } from './constants';

// Single source of truth for "does this user have access to a feature-gated
// surface?". The menu uses it to dim locked items; route guards use it to
// redirect to /not-available. Keeping both call sites on this predicate
// prevents the menu and the guard from drifting apart when the rule changes.
const hasFeatureAccess = (feature: JwtFeature, features: JwtFeature[]) =>
  features.includes(feature);

// `beforeLoad` factory for any feature-gated route. Reads the JWT-derived
// feature list from the store threaded through router context, and throws a
// redirect to /not-available when the user lacks the required flag.
const featureGuard =
  (feature: JwtFeature) =>
  ({ context }: { context: { store: Store<Types.RootState> } }) => {
    const features = userSelectors.features(context.store.getState());
    if (!hasFeatureAccess(feature, features)) {
      throw redirect({ to: routes.notAvailable, replace: true });
    }
  };

export { featureGuard, hasFeatureAccess };
